import { useCallback, useEffect, useState } from "react";

const KEY = "ww_favourites";
const EVT = "ww:favourites";

function read() {
  try {
    const v = JSON.parse(localStorage.getItem(KEY) || "[]");
    return Array.isArray(v) ? v.filter((s) => typeof s === "string") : [];
  } catch { return []; }
}

function write(slugs) {
  try { localStorage.setItem(KEY, JSON.stringify(slugs)); } catch {}
  window.dispatchEvent(new CustomEvent(EVT));
}

// Shortlist kept in the visitor's browser; every consumer stays in sync via a
// window event so hearts in the hall, grid, detail and drawer agree.
export default function useFavourites() {
  const [slugs, setSlugs] = useState(read);

  useEffect(() => {
    const sync = () => setSlugs(read());
    window.addEventListener(EVT, sync);
    window.addEventListener("storage", sync);
    return () => {
      window.removeEventListener(EVT, sync);
      window.removeEventListener("storage", sync);
    };
  }, []);

  const has = useCallback((slug) => slugs.includes(slug), [slugs]);
  const toggle = useCallback((slug) => {
    const cur = read();
    write(cur.includes(slug) ? cur.filter((s) => s !== slug) : [...cur, slug]);
  }, []);
  const remove = useCallback((slug) => write(read().filter((s) => s !== slug)), []);
  const clear = useCallback(() => write([]), []);

  return { slugs, count: slugs.length, has, toggle, remove, clear };
}
